import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {NgbCollapseModule, NgbDropdown, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {Principal} from '@app/core/auth/principal.service';
import {AuthentificationService} from '@app/security/authentification.service';
import {Globals} from '@shared/util/globals';
import {delay, take} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {NgClass, NgIf} from '@angular/common';
import {LANGUAGES} from '@app/core/language/language.constants';
import {LogoMarianneComponent} from "@shared/logo-marianne/logo-marianne.component";

@Component({
    selector: 'ned-navbar',
    templateUrl: './navbar.component.html',
    standalone: true,
    imports: [
        RouterLinkActive,
        RouterLink,
        NgIf,
        TranslateModule,
        FontAwesomeModule,
        NgbCollapseModule,
        NgClass,
        NgbDropdownModule,
        LogoMarianneComponent,
    ],
})
export class NavbarComponent implements OnInit, OnDestroy {

    @ViewChild('accountLink', {static: false}) accountLink!: ElementRef<HTMLElement>;
    @ViewChild('firstNavLink', {static: false}) firstNavLink!: ElementRef<HTMLElement>;
    @ViewChild('rla8', {static: false}) rla8!: ElementRef<object>;
    @ViewChild('dropAideEl', {static: false}) dropAideEl!: ElementRef<HTMLElement>;

    isNavbarCollapsed: boolean;
    languages: string[];
    nomPrenom = '';
    authenticate = false;
    recupeNomPrenom = false;
    authSubscription: Subscription | undefined;

    constructor(
        private principal: Principal,
        private authService: AuthentificationService,
        public globals: Globals,
    ) {
        this.isNavbarCollapsed = true;
        this.languages = LANGUAGES;

        // Subscription à l'authentification pour gestion déconnexion
        if (!this.authSubscription) {
            this.authSubscription = this.principal.getAuthenticationState()
                .pipe(delay(0))
                .subscribe(() => {
                    this.checkAuthentification();
                });
        }
    }

    ngOnInit() {
        // Vérification de l'authentification
        this.checkAuthentification();
    }

    ngOnDestroy() {
        if (this.authSubscription) {
            this.authSubscription.unsubscribe();
        }
    }

    collapseNavbar() {
        this.isNavbarCollapsed = true;
    }

    deconnexion() {
        this.collapseNavbar();
        this.authService.logoutByClick();
    }

    isAuthenticated() {
        return this.authenticate;
    }

    getNomPrenom() {
        if (!this.recupeNomPrenom && this.authenticate && this.nomPrenom.length <= 0) {
            this.authService.detectionActivite();
            this.principal.identity().pipe(take(1)).subscribe(id => {
                this.nomPrenom = id.prenom + ' ' + id.nom;
            });
        }
    }

    toggleNavbar() {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    }

    connectionToFC(pageCallBack: string): void {
        window.open(this.authService.getAuthorizeFC(pageCallBack), '_self');
    }

    checkAuthentification() {
        if (this.principal.isAuthenticated()) {
            this.authenticate = true;
            this.getNomPrenom();
            this.recupeNomPrenom = true;
        } else {
            this.authenticate = false;
        }
    }

    onMouseenter(drop: NgbDropdown) {
        drop.open();
    }

    onMouseleave(drop: NgbDropdown) {
        drop.close();
        this.dropAideEl.nativeElement.blur();
    }

    onClick(drop: NgbDropdown, ev: Event) {
        if (!drop.isOpen()) {
            this.dropAideEl.nativeElement.blur();
        }
    }
}
